import React from "react";
import { connect } from "react-redux";
import { Route, Switch, Redirect } from "react-router-dom";
import Gateway from "../../app/layouts/pages/gateway";
import Search from "../../app/layouts/pages/search";
import Login from "../../app/layouts/pages/login";
import Logout from "../../app/layouts/pages/logout";
import Forgot from "../../app/layouts/pages/login/forgot";
import Welcome from "../../app/layouts/pages/welcome";
import Register from "../../app/layouts/pages/register";
import Reset from "../../app/layouts/pages/user/reset";
import SignUp from "../../app/layouts/pages/signup";
import MyList from "../../app/layouts/pages/myList";
import GeoRestricted from "../../app/layouts/pages/GeoRestricted";
import { isUserLogged } from "../../store/utils/helpers";

/**
 * Auth guard for the routes that depend on the session.
 *
 * It reads the session through connect (the store of the current request)
 * instead of calling isUserLogged() directly: on the server that store is
 * shared by the whole process, so a direct read can resolve a request with
 * another visitor's session. Only the guard is connected — keeping <Switch>
 * and <Route> unconnected so router updates are never blocked.
 */
const RequireAuth = connect(state => ({ isLogged: isUserLogged(state) }))(
  ({ isLogged, whenLogged, whenAnonymous }) =>
    isLogged ? whenLogged : whenAnonymous,
);

const Routes = () => (
  <Switch>
    <Route exact path="/no-disponible" component={GeoRestricted} />
    <Route exact path="/user/reset" component={Reset} />
    <Route exact path="/login" component={Login} />
    <Route exact path="/logout" component={Logout} />
    <Route exact path="/login/recordar-contrasena" component={Forgot} />
    <Route exact path="/bienvenido" component={Welcome} />
    <Route exact path="/registro" component={Register} />
    <Route
      exact
      path="/registro"
      render={props => (
        <RequireAuth
          whenAnonymous={<SignUp {...props} />}
          whenLogged={<Redirect to="/mi-perfil" />}
        />
      )}
    />
    <Route
      exact
      path="/mi-perfil"
      render={props => (
        <RequireAuth
          whenLogged={<SignUp {...props} hideCloseButton />}
          whenAnonymous={<Redirect to="/login" />}
        />
      )}
    />
    <Route
      exact
      path="/mi-lista/"
      render={props => (
        <RequireAuth
          whenLogged={<MyList {...props} />}
          whenAnonymous={<Redirect to="/registro" />}
        />
      )}
    />
    <Route exact path="/buscar/:term/:page?" component={Search} />
    <Route exact path="/medios/:slug/categoria/:category" component={Gateway} />
    <Route exact path="/:slug/marca/:brand" component={Gateway} />
    <Route exact path="/:slug*" component={Gateway} />
  </Switch>
);

export default Routes;
